import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = "";
export const API = `${BACKEND_URL}/api`;

export const FALLBACK_CONTENT = {
  site: {
    hero_kicker: "Big Bag Films · Production",
    hero_headline: "FULL\nPRODUCTION\nOF EMOTIONS",
    hero_sub: "Видеоначинка для маркетинга и событий",
    hero_phase_2_kicker: "Метод",
    hero_phase_2_headline: "ДОСТАВЛЯЕМ\nОЩУЩЕНИЯ\nИ ВПЕЧАТЛЕНИЯ",
    hero_phase_3_kicker: "Совсем скоро",
    hero_phase_3_headline: "ВАШ ПРОЕКТ\nИЗ БУДУЩЕГО\nЖДЁТ ВАС",
    showreel_url: "https://vimeo.com/975069005",
    method_title: "Наш метод",
    method_subtitle: "32 слова о нашем подходе",
    method_steps: [
      "Исследование", "Выработка гипотез", "Проверка", "Анализ и доработка",
      "Описание идеи и сценария", "Подбор релевантной команды",
      "Оптимизация расходов", "Подготовка к производству", "Производство",
      "Постобработка материала", "Подготовка к релизу",
      "Обучение на основе полученных данных", "Выработка новых гипотез",
    ],
    impressions_title: "ДОСТАВЛЯЕМ\nОЩУЩЕНИЯ\nИ ВПЕЧАТЛЕНИЯ",
    impressions_body:
      "Big Bag Films — продакшн полного цикла. Десять лет мы упаковываем смыслы брендов в кинематографичные сцены: от съёмочной площадки до арен и сложных LED-сетапов.",
    stats: [
      { value: "10+", label: "лет на рынке" },
      { value: "200+", label: "проектов за последние 5 лет" },
      { value: "12", label: "наград, включая лучшую визуальную инсталляцию (MARSPO)" },
      { value: "20+", label: "человек в команде" },
      { value: "30+", label: "продакшенов запланировано на 2025 год" },
    ],
    team_title: "Кто стоит за кадром",
    clients_title: "Наши клиенты",
    skills_title: "Доказательства навыков",
    skills_subtitle: "Три точки, в которых наш подход уже даёт измеримый результат.",
    skills_proof: [],
    social_vimeo: "#",
    social_behance: "#",
    social_telegram: "#",
    discuss_button: "Обсудить проект",
    premiere_kicker: "Премьера / 007",
    premiere_headline: "ВЫ — ГЛАВНЫЙ\nГЕРОЙ ПРЕМЬЕРЫ",
    premiere_lead:
      "Это вы делаете премьеры. Получите золотой билет в свой проект из будущего: мы соберём для него команду, оптику и звук, и вместе выпустим его на большие экраны.",
    premiere_button: "Получить золотой билет",
    contact_email: "bigbagfilms@gmail.com",
    contact_site: "bigbagfilms.ru",
    contact_vimeo: "https://vimeo.com/bigbagfilms",
  },
  projects: [],
  team: [],
  clients: [],
  testimonials: [],
};

export function useContent() {
  const [content, setContent] = useState(FALLBACK_CONTENT);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let active = true;
    axios
      .get(`${API}/content`)
      .then((res) => {
        if (!active) return;
        const data = res.data || {};
        setContent({
          site: { ...FALLBACK_CONTENT.site, ...(data.site || {}) },
          projects: data.projects || [],
          team: data.team || [],
          clients: data.clients || [],
          testimonials: data.testimonials || [],
        });
        setLoaded(true);
      })
      .catch(() => {
        // Fallback already in state
        setLoaded(true);
      });
    return () => {
      active = false;
    };
  }, []);

  return { content, loaded };
}
